import {
    Button, Image, ImageType, Layout, LookupModelSelectionEvent, Panel, ScreenStack, SlideoutDecorator, Toast
} from "@mcleod/components";
import { AutogenLayoutDeliveryReceipt } from "./autogen/AutogenLayoutDeliveryReceipt";
import { Api, ModelRow } from "@mcleod/core";
import { CommonDialogs } from "@mcleod/common";

interface DeliveryReceiptProps {
    order_id: string,
    customer_id: string,
    _lookup_customer_id: ModelRow,
}

export class DeliveryReceipt extends AutogenLayoutDeliveryReceipt {
    _props: any;


    private sendButton: Button = new Button({
        dataSource: this.mainDataSource,
        busyWhenDataSourceBusy: true,
        caption: "Send",
        rowBreak: false,
        backgroundColor: "primary",
        color: "primary.reverse",
        borderWidth: 0,
        width: 150,
        onClick: () => this.buttonSendOnClick()
    });




    static showDeliveryReceiptSlideout(props: DeliveryReceiptProps) {
        const layout = Layout.getLayout("lme/dispatch/DeliveryReceipt") as DeliveryReceipt;
        new SlideoutDecorator({
            layout,
            title: "Delivery Receipt",
            width: window.innerWidth * 0.5,
            fillVerticalSpace: true,
            layoutLoadListeners: async () => {
                layout._props = props;
                await layout.mainDataSource.search({ order_id: props.order_id });
                layout.setupContactListeners(props.customer_id);
                layout.loadPreview(layout.activeRow);
            },
            addlComponents: layout.sendButton
        });
    }

    private setupContactListeners(customer_id: string) {
        this.textboxContactName.addBeforeLookupModelSearchListener(event => {
                event.filter.parent_row_id = customer_id;
                event.filter.parent_row_type = "C";
                event.filter.is_active = "Y";
        });

        this.textboxContactName.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            if (event.hasSelection() === true) {
                const emailAddress = event.selection.get("email", null);
                if (emailAddress) {
                    this.mainDataSource.searchRow.set("to_address", emailAddress);
                    this.textboxEmail.displayData(this.mainDataSource.searchRow, null, 0);
                }
            }
        });
    }

    loadPreview(activeRow: ModelRow) {
        this.panelPDF.removeAll();

        if (activeRow.get("error_message") != null) {
            CommonDialogs.showError(activeRow.get("error_message"));
        }
        else {
            const image = new Image({ imageType: ImageType.PDF, fillHeight: true, fillRow: true, id: "rateConPreview" });
            image.imageBytes = activeRow.get("document");
            this.panelPDF.add(image);
        }
    }

    async textboxDefaultTemplateOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection() === true) {
            await this.mainDataSource.search({ order_id: this._props.order_id, template_number: event.selection.get("template_number") });
            this.loadPreview(this.activeRow);
        }
    }

    buttonSendOnClick() {
        if (this.validateSimple()) {
            this.sendButton.busy = true;
            const body =
            {
                order_id: this._props.order_id,
                template_number: this.textboxTemplate.getFirstLookupModelData().data["template_number"],
                subject: this.textboxSubject.text,
                comment_text: this.textboxComment.text,
                email_address: this.textboxEmail.text
            }
            Api.post(this.mainDataSource.url, body, null, null).then(response => {
                if (response.data[0]?.error_message) {
                    CommonDialogs.showError(response.data[0].error_message);
                    this.sendButton.busy = false;
                }
                else {
                    this.slideOut();
                    Toast.showToast("Delivery Receipt Sent", null, { targetPanel: ScreenStack.getPreviousToastTarget() });
                }
            });
        }
    }
}
